package fr.manyverse.app.infrastructure.repository

import fr.manyverse.app.AppLogger
import fr.manyverse.app.domain.model.FeedbackType
import fr.manyverse.app.domain.repository.UserFeedbackRepository
import fr.manyverse.app.infrastructure.error.mapToDomainException
import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.postgrest.from
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

private const val TAG = "UserFeedbackRepository"
private const val FEEDBACK_TABLE = "user_feedbacks"

class SupabaseUserFeedbackRepository(
    private val supabaseClient: SupabaseClient
) : UserFeedbackRepository {

    override suspend fun submitFeedback(
        userId: String,
        userEmail: String,
        type: FeedbackType,
        message: String
    ): Result<Unit> {
        return try {
            val insertDto = UserFeedbackInsertDto(
                userId = userId,
                userEmail = userEmail,
                feedbackType = type.name,
                message = message
            )

            supabaseClient
                .from(FEEDBACK_TABLE)
                .insert(insertDto)

            Result.success(Unit)
        } catch (e: Exception) {
            AppLogger.warn(TAG, "Failed to submit feedback for user=$userId")
            Result.failure(mapToDomainException(e, "feedback"))
        }
    }
}

@Serializable
private data class UserFeedbackInsertDto(
    @SerialName("user_id") val userId: String,
    @SerialName("user_email") val userEmail: String,
    @SerialName("feedback_type") val feedbackType: String,
    @SerialName("message") val message: String
)
